import * as React from 'react';
const SvgNavCentral = (props) => (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props),
    React.createElement("g", { fill: "#2D2E2E", clipPath: "url(#navCentral_svg__a)" },
        React.createElement("path", { d: "M3 3h4.5v4.5H3zM16.5 3H21v4.5h-4.5zM16.5 16.5H21V21h-4.5zM3 16.5h4.5V21H3zM7.5 7.5h9v9h-9z" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "navCentral_svg__a" },
            React.createElement("path", { fill: "#fff", d: "M3 3h18v18H3z" })))));
export default SvgNavCentral;
//# sourceMappingURL=NavCentral.js.map
// @zapier/design-system@6.27.0 (617a97f69)
